/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_Action_NameInputs */

const en_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rendering audio`)
};

const fr_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rendu audio`)
};

const de_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiowiedergabe`)
};

const it_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rendering audio`)
};

const ru_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`рендеринг звука`)
};

const es_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`renderizado de audio`)
};

const zh_cn2_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渲染音频`)
};

const ja_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオのレンダリング`)
};

const hi_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो रेंडरिंग`)
};

const pt_pt2_render_audio_action_name = /** @type {(inputs: Render_Audio_Action_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`renderização de áudio`)
};

/**
* | output |
* | --- |
* | "rendering audio" |
*
* @param {Render_Audio_Action_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_action_name = /** @type {((inputs?: Render_Audio_Action_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Action_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_action_name(inputs)
	if (locale === "de") return de_render_audio_action_name(inputs)
	if (locale === "it") return it_render_audio_action_name(inputs)
	if (locale === "ru") return ru_render_audio_action_name(inputs)
	if (locale === "es") return es_render_audio_action_name(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_action_name(inputs)
	if (locale === "ja") return ja_render_audio_action_name(inputs)
	if (locale === "hi") return hi_render_audio_action_name(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_action_name(inputs)
	return en_render_audio_action_name(inputs)
});